import styled from 'styled-components'
import { Tabs, TabPanel, TabList, Tab } from 'react-tabs'
import YouTube from 'react-youtube'

export const BeforeAfter = styled.section`
  margin: 50px auto 100px;
  div {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .gatsby-image-outer-wrapper,
    .gatsby-image-wrapper {
      @media (max-width: 600px) {
        width: 360px;
        height: 215px;
      }
    }
  }

  h2 {
    font-weight: 400;
    text-align: center;
  }
`

export const Video = styled(YouTube)`
  margin-top: 25px;
  width: 90vw;
  height: 50.75vw;
  max-height: 576px;
  max-width: 1024px;
  border-radius: 8px;
  margin: 50px auto;
  display: flex;
  justify-content: center;
`

export const Content = styled.div`
  max-width: 850px;
  width: 90%;
  margin: 50px auto 100px;
  h2 {
    color: ${props => props.theme.colors.primary};
  }
  span {
    font-size: 22px;
    line-height: 1.4;
    margin: 1rem 0 2rem;
    display: block;
  }
  h4 {
    font-weight: 400;
    color: ${props => props.theme.colors.primary};
    font-size: 20px;
  }
`

export const StyledTabList = styled(TabList)`
  display: inline-flex;
  list-style: none;
  padding: 0;
  border-radius: 30px;
  margin-bottom: 3rem;
  cursor: pointer;

  @media (max-width: 600px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`

export const StyledTab = styled(Tab)`
  padding: 0.75rem 1.5rem;
  border: 1px solid ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
  font-weight: 500;

  @media (max-width: 600px) {
    margin-top: 1rem;
  }

  border-radius: 30px;
  margin: 0 0.2rem;

  &.react-tabs__tab--selected {
    color: #fff;
    background-color: ${props => props.theme.colors.primary};
  }

  /* &:last-child {
    border-right: none;
  } */
`

export const StyledTabs = styled(Tabs)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 850px;
  margin: 0 auto 60px;
  width: 90%;

  div {
    h4 {
      font-weight: 400;
      font-size: 20px;
      color: ${props => props.theme.colors.primary};
    }
  }
  h2 {
    font-weight: 400;
    text-align: center;
    margin-bottom: 1em;
  }
`
